import { render, staticRenderFns } from "./StatisticsChart.vue?vue&type=template&id=71430e7e"
import script from "./StatisticsChart.vue?vue&type=script&lang=js"
export * from "./StatisticsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports